import { Box } from "@mui/material";
import Header from "./Header";
import { useRole } from "../hooks/useRole";
import Footer from './Footer'; 
import CareCopilotWidget from './copilot/CareCopilotWidget'
import DefaultPracticeBanner from './DefaultPracticebanner'

export default function Layout({ children, noPadding = false }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header with Navigation & User Menu */}
      <Header />

      {/* Reminder for Providers still on the Default Practice */}
      <DefaultPracticeBanner />

      {/* Main Content */}
      <Box sx={{ display: "flex", flex: 1 }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: noPadding ? 0 : 3,
            backgroundColor: "#f7fbff",
          }}
        >
          {children}
        </Box>
      </Box>
      <CareCopilotWidget/>
      
      {/* Footer */}
      <Footer />
    </Box>
  );
}